export default __webpack_public_path__ + "static/media/community.6f8c109f.webp";